module.exports = __webpack_public_path__ + "img/workContents03-01.78a5bea0.gif";